<template>
  <teleport to="body">
    <div class="omni-modal-overlay" @click.self="close">
      <div class="omni-modal-container" :class="modalClass">
        <div class="omni-modal-header" :class="headerClass">
          <div class="omni-modal-title" :class="titleClass">
            <slot name="header"></slot>
          </div>
          <button type="button" class="omni-modal-close" @click="close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <div class="omni-modal-body" :class="bodyClass">
          <slot name="body"></slot>
        </div>

        <div v-if="isFooterVisible" class="omni-modal-footer" :class="footerClass">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'OModal',
  props: {
    modalClass: { type: String, default: '' },
    headerClass: { type: String, default: '' },
    titleClass: { type: String, default: '' },
    bodyClass: { type: String, default: '' },
    footerClass: { type: String, default: '' },
    isFooterVisible: { type: Boolean, default: true },
  },
  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.omni-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.omni-modal-container {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 550px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  padding-right: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: modal-appear 0.3s ease-out;
}

.omni-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.omni-modal-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
}

.omni-modal-close {
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s;
}

.omni-modal-close:hover {
  color: #ef4444;
}

.omni-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.omni-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@keyframes modal-appear {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 640px) {
  .omni-modal-container {
    max-width: 100%;
    margin-bottom: 0;
    border-radius: 12px 12px 0 0;
    position: fixed;
    bottom: 0;
  }
}
</style>